// DS: MO5.3
import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton/TextButton';
import UserAvatar from '../../../../../../User/Avatar/UserAvatar';
import UserLink from '../../../../../../User/Link/UserLink';
import Timestamp from '../../../../../../Timestamp/Timestamp';
import s from './AdoptedOnSide.scss';
const AdoptedOnSide = ({ deviation , className  })=>{
    var _deviation_extended, _deviation_extended_adoptable, _deviation_extended1, _deviation_extended_adoptable1, _deviation_extended2, _deviation_extended_adoptable2, _deviation_extended3, _deviation_extended_adoptable3;
    const { t  } = useTranslation();
    const owner = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.owner;
    const downloadLink = ((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_adoptable1 = _deviation_extended1.adoptable) === null || _deviation_extended_adoptable1 === void 0 ? void 0 : _deviation_extended_adoptable1.isOwner) && ((_deviation_extended2 = deviation.extended) === null || _deviation_extended2 === void 0 ? void 0 : (_deviation_extended_adoptable2 = _deviation_extended2.adoptable) === null || _deviation_extended_adoptable2 === void 0 ? void 0 : _deviation_extended_adoptable2.assetSourceUrl);
    if (!owner) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root-inner']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        size: 24,
        user: owner
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['adopted-by']
    }, t('sidebar.adoptableInfo.adopted.adoptedBy', {
        postProcess: 'reactPostprocessor',
        userLink: /*#__PURE__*/ React.createElement(UserLink, {
            className: s['username'],
            user: owner
        }, owner.username)
    })), /*#__PURE__*/ React.createElement(Timestamp, {
        className: s['timestamp'],
        timestamp: (_deviation_extended3 = deviation.extended) === null || _deviation_extended3 === void 0 ? void 0 : (_deviation_extended_adoptable3 = _deviation_extended3.adoptable) === null || _deviation_extended_adoptable3 === void 0 ? void 0 : _deviation_extended_adoptable3.lastTradeTs
    }), downloadLink && /*#__PURE__*/ React.createElement(TextButton, {
        className: s['download-link'],
        href: downloadLink,
        size: "medium",
        variant: "main"
    }, t('sidebar.adoptableInfo.adopted.downloadLink'))));
};
AdoptedOnSide.displayName = 'AdoptedOnSide';
export default AdoptedOnSide;
